import LabelProvider from "core/components/label/LabelProvider";


export default LabelProvider.create({

	Placeholder: { k: "search.placeholder", v: "Search Keywords" },

	Clear: { k: "search.clear", v: "Clear" },

	Submit: { k: "search.submit", v: "Submit" }

});



// WEBPACK FOOTER //
// ./src/panels/refineText/RefineText.labels.ts